import { BASE_URL } from '../config';
import axiosApiInstance from '../../interceptors/axiosApiInstance'

//https://www.nicesnippets.com/blog/react-js-file-upload-example-with-axios
const LicenseService = {
    addNewLicense: async function (licenseFile) {
        try {
            let formData = new FormData();
            formData.append('file', licenseFile);
            const response = await axiosApiInstance.post(await BASE_URL + '/license/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLicenseDetail: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/license');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    developmentCheck: async function (params) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/license/development/check', { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default LicenseService;
